<!--
 * @Author: Merlin
 * @Date: 2024-01-12 14:35:54
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-29 14:30:49
 * @Description: 
-->
<template>
    <NuxtLayout name="game-coat"
        :topHeight="oStyleObj.outer"
    >
        <template #bgImg>
            <!-- ↓ 旧写法：globalStore.client ? oStyleObj.bgImg : '' -->
            <img :src="oStyleObj.bgImg" 
                :style="oStyleObj.oBgControl" 
            />
        </template>
        <template #panel-left>
            <ClientOnly>
                <BetOptions
                    class="four-btn-group"
                    :round-data="round"
                    :update-round="updateRound"
                    :handsUser1="handsUser1"
                    :handsUser2="handsUser2"
                    :handsUser1State="handsUser1State"
                    :handsUser2State="handsUser2State"
                    :is-updating-round="isUpdatingRound"
                    :roundStatus="roundStatus"
                    :doRequest="doRequest"
                />
                <CasinoBetOptionSection
                    :showSwitch="false" 
                    class="mt-2"
                    v-model:bet-amount-modal-value="oForm.amount"
                    v-model:isAuto="isAudoFake"
                    :is-submiting="gamePlaying"
                    :bet-submit="submitTheBet"
                    :is-fast="isFast"
                    :expectedReward="totalAmountAllBets"
                    :expectedRewardLabel="$t('GameBlackJack.TotalBet')"
                    :normalBtnDisabled="isDiabled"
                />
                <div class="mt-3 mode-witch-wrap"
                    @click="changeMode"
                >
                    <Toggle
                        class=""
                        :preLabel="$t('GameBlackJack.ProMode')"
                        :disabled="gamePlaying"
                        v-model="isProMode"
                    ></Toggle>
                    <!-- 左右分界 -->
                    <!-- <span class="total" v-if="isProMode" >
                        <small>{{$t('GameBlackJack.TotalBet')}}:</small>
                        <CurrentCoin size="18px" />
                        {{ totalAmountAllBets }}
                    </span> -->
                </div>
                <GameControls
                    v-show="isProMode"
                    class="mt-3"
                    :o-form="oForm"
                    :disabled="isDiabled" 
                    :ref="el=>oProInput=el"
                />
            </ClientOnly>
        </template>
        <!--
            左右大分界
        -->
        <template #playing-area-right>
            <!-- 需要动态设定高度 --> 
            <div class="game-layout__game-inner"
                :style="{
                    height: oStyleObj.inner,
                    width: '100%',
                }"
            >
                <div class="game-wrapper" active-chip="[object Object]" available-chips="1,10,100">
                    <div class="pillar" ></div>
                    <!-- ↓ 重要容器， -->
                    <section class="game-wrapper-table" style="transform: scale(1)">
                        <SideBar v-if="isProMode" />
                        <ProWin :round="round" v-if="isProMode" />
                        <!-- ↑ 特殊内容 -->
                        <!-- ↓ 庄家与玩家的手牌 -->
                        <TableLine
                            :dealer="true"
                            :hands="handsBot"
                            :animation="animation"
                        />
                        <div style="height: 45px"></div>
                        <TableLine
                            :round="round"
                            :hands="handsUser1"
                            :hands2="handsUser2"
                            :handsUser1State="handsUser1State"
                            :handsUser2State="handsUser2State"
                            :animation="animation"
                        />
                        <!-- ↓新的原型图不显示此项 -->
                        <div id="tableDeck"
                            class="table-deck"
                        ></div>
                    </section>
                </div>
            </div>
        </template>
    </NuxtLayout>
</template>

<script lang="ts">
import BlackJsackMp3 from './mp3/music_loop.mp3';
import FlipMp3 from './mp3/flip.mp3';
import WinMp3 from './mp3/win.mp3';
import DrawMp3 from './mp3/draw.mp3';
import LoseMp3 from './mp3/lose.mp3';
import SlideMp3 from './mp3/slide.mp3';
import ClearMp3 from './mp3/clear.mp3';
import bgImage from './img/blackjack-bg.webp';
import bgImageMobile from './img/game-bg-mob.webp'; 
// ==== ↑ 音乐 + 图片 ↑ ===========================================================
import GameControls from './_components/GameControls.vue';
import BetOptions from './_components/BetOptions.vue';
import Card from './_components/Card.vue';
import TableLine from './_components/TableLine.vue';
import SideBar from './_components/SideBar.vue';
import ProWin from './_components/ProWin.vue';
// ==== ↑ Vue 组件 ↑ ===========================================================
import useGlobalStore from '~/stores/global';
import useSettingsStore from '~/stores/settings';
import { useJoinStateStore } from '~/stores/cansino/joinState';
// ==== ↑ stores ↑ ===========================================================
import { Action, oMethods, CardsBox, checkIfExploded } from './ts/blackjackGame';
import useTranslation from '~/i18n/useTransLation';
import { createBettingForm, useBettingToolkit } from '~/common/js/bettingToolkit';
import { useBlackJackSocket } from '@/socket/game/blackJack';
import {betableCheck} from '@/common/js/betHelper';
import oScssVar from '~/common/style/game.module.scss';
import type {
    RoundDataInterface,
    userStatus,
    ParamsPart,
    ProModeInfo,
    Params2Submit,
    CardInterface,
    AddCardTask,
} from './ts/blackjackGame';


const ANIMATION_DELAY = 200;
const {EMIT_BLACKJACK_BET} = useBlackJackSocket();
const isDev = import.meta.dev;
// type Target = 'handsBot' | 'handsUser1' | 'handsUser2';


export default {
    name: 'blackjack',
    components: {
        BetOptions, // 4大按钮 
        Card,
        TableLine,
        // -- ↓ pro 模式专用 ---------------
        SideBar,
        ProWin,
        GameControls,
    },
    data() {
        const oForm = createBettingForm({
            amount: 0,
            // isSubmiting: false, // 状态为 false 则停止自动下注（此游戏没有自动模式）
        });
        const t = useTranslation();
        const oStores = {
            oSettings: useSettingsStore(),
            globalStore: useGlobalStore(),
            oUserStore: useUserStore(),
            oJoinStateStore: useJoinStateStore(),
        };
        // 音乐列表
        const oMusic =
            import.meta.client &&
            new MusicControler({
                bg: {
                    src: BlackJsackMp3,
                    loop: true,
                    isBGM: true, // true-false 表示音量取自 globalVolume, globalSoundEffects
                },
                flip: { src: FlipMp3, },
                win: { src: WinMp3, },
                draw: { src: DrawMp3, },
                lose: { src: LoseMp3, },
                slide: { src: SlideMp3, },
                clear: { src: ClearMp3, },
            } as any);
        const firstHand = {
            cards: [],
            amount: 0,
            winAmount: 0,
            type: 0,
            points: 0,
        };
        const round:RoundDataInterface = {
            firstHand,
            secondHand: deepCopy(firstHand), 
            dealerHand: { cards: [], points: 0 },
            status: '',
            currency: '', // usd, cny, 
            multi:0,
            winAmount:0,
            initialBetAmount: 0,
            // insuranceAmount: void 0, // 0有特殊含义，表示玩家已经放弃买保险，所以这里不能默认放0
            // --- ↓ pro mode 专用 -----------------
            pairsBetAmount: 0,
            pairsWinAmount: 0,
            tripleBetAmount: 0,
            tripleWinAmount: 0,
        };
        return {
            isAudoFake: false, // 
            ...{ // ← 庄家的数据
                handsBot: [] as CardInterface[], // 卡牌列表，将交给子组件 
                handsBotPoints: [0, 0],
            },
            ...{ // ← 玩家数据
                handsUser1: [] as CardInterface[], // 卡牌列表，将交给子组件 
                handsUser2: [] as CardInterface[], // 卡牌列表，将交给子组件 
                handsUser1State: '' as userStatus,
                handsUser2State: '' as userStatus,
                handsUser1Points: [0, 0],
                handsUser2Points: [0, 0],
            },
            oScreen: {
                iWithB: Number.parseInt(oScssVar.myWidthB),
            },
            t,
            oForm,
            oMusic,
            bgImage,
            bgImageMobile, 
            isProMode: !!0, // pro 模式标记 
            ...oStores,
            round,
            roundEmptyObj: Object.freeze(deepCopy(round)),
            roundStatus: '' as userStatus,
            isUpdatingRound: false,
            handsBotState: '' as 'play' | 'locked' | 'await' | 'split',
            showHideAnim: false,
            initID: Math.random(), 
            sHadhLoaded: '',
            // ■■■■■■■■ ↓ Pro 模式专用 ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
            oProInput: null, // 输入框子组件
        };
    },
    computed: {
        // ↓ 值为真表示游戏进行中，此时禁用相按钮等
        gamePlaying(){
            return this.round.status == 'play';
        },
        // ↓ 下注总金额 
        totalAmountAllBets() {
            if (!this.isProMode) return 0;
            let sumValue = (
                Number(this.oForm.amount || 0) +
                Number(this.oProInput?.pairsAmount || 0) +
                Number(this.oProInput?.tripleAmount || 0)
            );
            return sumValue;
        },
        isDiabled() {
            // ↓ 任一满足即禁用
            const aCondition = [
                this.isUpdatingRound,
                this.roundStatus === 'play',
            ];
            const bResult = aCondition.some(Boolean);
            return bResult;
        },
        isFast() {
            return this.oSettings.inhouseGames.blackjack.fast;
        },
        animation() {
            return this.oSettings.inhouseGames.blackjack.animation;
        },
        // ↓ 移动模式 （暂时停用） 
        // mobileMode(){
        //     return this.globalStore.innerWidth <= 550; 
        // },
        // ↓ 样式相关设定 
        oStyleObj(){
            const {innerWidth} = this.globalStore;
            const oResult = {
                outer: '603px', // 880px
                oBgControl: {}, // 默认为空 
                inner: '507px', // auto
                bgImg: this.bgImage,
                panelDown: innerWidth <= this.oScreen.iWithB, // 
            };
            if (innerWidth < 600){
                oResult.inner = 'auto';
            }
            if (innerWidth <= 550){
                oResult.bgImg = this.bgImageMobile;
                oResult.outer = '580px';  // 880px
                oResult.oBgControl = {
                    'object-position': 'center top',
                    // 'object-fit': 'contain', 
                };
            }
            return oResult;
        },
        // ↓ 为移动端重新设定布局 
        sOptionsShowAt(){
            // 'above-amount' : 'default'
            if (this.oStyleObj.panelDown){
                return 'above-amount';
            }
            return 'default';
        },
    },
    // =============== 👆 date, computed ==============================
    // =============== 👆 date, computed ==============================
    // =============== 👆 date, computed ==============================
    watch: {
        globalStore: {
            deep: true,
            immediate: true,
            handler(oNew) {
                if (oNew.innerWidth <= 550) {
                    console.log("mobile mode");
                } else {
                    console.log("desk mode");
                }
            },
        },
        // ↓ 加载未完成的游戏 
        'oJoinStateStore.lastRound': {
            deep: true,
            immediate: true,
            async handler(oRound) {
                if (import.meta.server || !oRound?.hash) return; 
                if (this.sHadhLoaded  == oRound.hash) return; 
                this.removeOldData(); // ←执行清空，重要！
                await this.$nextTick();
                // console.log('🐸 新旧 hash 如下：');
                // console.log(this.sHadhLoaded, '◆', oRound.hash);
                this.sHadhLoaded  = oRound.hash; 
                const oLastRound = deepCopy(oRound); 
                oLastRound.reload_ = true; // ←用于强调这是在刷新后加载的数据 
                console.log("1️⃣ 进行中的游戏： lastRound ↓\n", deepCopy(oLastRound));  
                this.updateRound(oLastRound, Action.Bet); 
                // pairsBetAmount tripleBetAmount 
                if (oLastRound.pairsBetAmount || oLastRound.tripleBetAmount){
                    this.isProMode = true;
                }
                showLastRoundLoadedInfo();
                this.oJoinStateStore.gameRunning = true; // 设为“游戏进行中” 
            },
        },
    },
    mounted() {
        this.initID = Math.random();
        useBettingToolkit(this.oForm); // 使赋值一个默认下注金额 
    },
    beforeUnmount(){
        this.oMusic.toDestory();
    },
    // =============== ↓ methods ↓ ==============================
    // =============== ↓ methods ↓ ==============================
    // =============== ↓ methods ↓ ==============================
    // =============== ↓ methods ↓ ==============================
    // =============== ↓ methods ↓ ==============================
    methods: {
        ...oMethods,
        // ↓ 用于检查 **
        check(tt) {
            const bResult = tt === this.initID;
            if (0 && !bResult && import.meta.dev){
                console.warn('check 未通过');
                // debugger;
            }
            return bResult; 
        },
        // ↓ 清空旧数据，
        removeOldData(){
            this.round = {} as RoundDataInterface; 
            // ↓ 庄家的数据
            this.handsBot = [] as CardInterface[];
            this.handsBotPoints = [0, 0];
            // ↓ 玩家数据
            this.handsUser1 = [] as CardInterface[]; // 卡牌列表，将交给子组件 
            this.handsUser2 = [] as CardInterface[]; // 卡牌列表，将交给子组件 
            this.handsUser1State = '' as userStatus;
            this.handsUser2State = '' as userStatus;
            this.handsUser1Points = [0, 0];
            this.handsUser2Points = [0, 0];
        },
        // ↓ 重要方法，更新牌桌内容 💥 
        // ↓ 用户每次操作每次请求，都将执行此方法 
        async updateRound(
            roundData: RoundDataInterface, 
            action?: Action, 
        ) {
            // Update round information and set animation flag 
            this.round = roundData; // ← 先保存起来，重要 
            this.isUpdatingRound = true; // ← 强调动画正在进行中，将在末尾恢复为 false 
            const initialID = this.initID; 
            const { dealerHand, firstHand, secondHand, status } = roundData;
            // ↓ 经查证：Stand 之后如果双方点数相同，状态仍是 cashout 
            const isGameEnded = ['cashout', 'lose'].includes(status);
            // console.log("游戏结束了吗：", isGameEnded, status); 
            // ======== ↑ 在顶部把变量准备好 ↑ ============================ 
            if (isGameEnded) {
                // ↓ 游戏结束，在此终止 
                this.afterPlayerHasLost();
                return;
            }
            // Handle other actions (join, Hit, Stand, Double) 
            const oTwoHands = {firstHand, secondHand}; 
            switch (action) {
                case Action.Bet:
                    // ↓ 分牌后刷新重载，会执行到此  
                    // const justSplited = secondHand?.type === 0; // 刚把牌分开
                    // if (justSplited){
                    //     await this.setEmptyTable(); 
                    //     break;
                    // }
                    // await this.showBet();
                    // ↑ 关闭以上语句，改用 setEmptyTable 
                    await this.setEmptyTable();
                    break;
                case Action.Split:
                    await this.showSplit({
                        ...oTwoHands,
                        startAnimID: initialID,
                    });
                    break;
                case Action.Hit:
                    await this.showHit({
                        ...oTwoHands,
                        startAnimID: initialID,
                    });
                    break;
                // ↓ 以下的 stand 和 double 只在两手牌的情况下会用到
                // ↓ 因为只有一手牌不会至此，会执行到 isGameEnded 
                case Action.Stand:
                    this.showStand(oTwoHands); 
                    break;
                case Action.Double:
                    // 点击 double 之后问题继续调用 stand 接口，所以动画在 stand 接口播放 
                    await this.showDouble(oTwoHands); 
                    break;
                default:
                    console.log('未知操作');
                    break;
            }
            // ↓ Update round status and reset animation flag
            this.roundStatus = status; 
            console.log('this.isUpdatingRound', false); 
            this.isUpdatingRound = false; 
        },
        // ↓ 专门在 “游戏结束” 之后执行  
        async afterPlayerHasLost(){
            this.oJoinStateStore.gameRunning = false; 
            const {
                dealerHand,
                firstHand,
                secondHand,
                status,
                insuranceAmount,
            } = this.round;
            const startAnimID = this.initID; 
            // TODO 玩家拆牌后如立即拿到两手的 21点，瞬间胜利的可能性或许存在，待考证 
            // const dealerGot21 = dealerHand.points == 21 && insuranceAmount && dealerHand.cards.length == 2;
            const gotBlackjack = firstHand.points == 21 && firstHand.cards.length == 2 && !secondHand; 
            // ↓ 玩家开局拿到 21 直接结束游戏（此时未必是获胜，因为庄家可能也是 21，是平局）
            // ↓ 这表示，开局直接结束游戏，需要设定空牌桌 
            if (gotBlackjack){
                await this.setEmptyTable();
            }
            await this.showEndRound({
                firstHand,
                secondHand,
                dealerHand,
                startAnimID,
                insuranceAmount,
            });
            this.roundStatus = status; 
            this.isUpdatingRound = false; 
        },
        // ↓ 更新牌桌之: 🎀 开局 
        // ↓ 传统开局才会执行到此，开局直接胜利不会执行到此 
        // ↓ 停用于 2024.05.09 17:56:39 星期四 
        // async showBet() {
        //     // ↓ 此方法内的语句全被此新方法替代了 
        //     await this.setEmptyTable(); 
        // },
        // ↓ 更新牌桌之: 🎀 split 
        async showSplit(oParams) { 
            const { firstHand , secondHand, startAnimID } = oParams;
            const iFirstHandLen = this.handsUser1.length; 
            if (iFirstHandLen == 2){
                this.handsUser1.pop();
            }
            // const initialCardID = this.handsUser1[1].cardID; 
            // Reset the first hand with its initial card
            // Add cards to the second hand
            await this.addCard(CardsBox.handsUser2, {
                cardID: secondHand.cards[0],
                exposed: true,
                goFast: true, 
            }); 
            // Add the second card to the first hand 
            await this.addCard(CardsBox.handsUser1, { cardID: firstHand.cards[1] });
            await this.addCard(CardsBox.handsUser2, { cardID: secondHand.cards[1] });
            // this.handsUser1[1].cardID = firstHand.cards[1];

            // Check if the animation should continue
            if (!this.check(startAnimID)) return;
            // Determine which hand is active and set its state to "split"
            this.activateCreentyHand(oParams);
        },
        // ↓ 返回 0 或 1，分别表示当前在聚焦第1把牌和第2把 
        getActiveSplitHandID(oParams) {
            const {firstHand, secondHand} = oParams; 
            // const {firstHand, secondHand} = this.round;
            // ↓ 没有第2把牌，自然当前在玩第1把牌
            if (!secondHand?.cards?.length) return 0; 
            let activeHandID = 0; // 默认在玩第1把牌 
            // If there is a second hand and the first hand's type is 2 (indicating a split), set the active hand ID to 1
            
            if (firstHand.type === 2 || firstHand.points >= 21) {
                activeHandID = 1; 
            }
            return activeHandID;
        },
        // ↓ 用于玩家有2把牌的时候，把当前的牌设为高亮 
        activateCreentyHand(oParams){ 
            if (!this.round?.secondHand?.cards?.length){
                return; // 没有第2把牌，不执行 
            }
            const activeSplitHandID = this.getActiveSplitHandID(oParams);
            if (activeSplitHandID === 0) {
                this.handsUser1State = 'split';
            } else {
                this.handsUser2State = 'split';
            }
        },

        // ↓ 更新牌桌之: 🎀 hit 
        async showHit(oParams) {
            const { firstHand, secondHand, startAnimID, } = oParams;
            const activeSplitHandID = this.getActiveSplitHandID(oParams);
            // Add cards for the first hand
            await this.addCardDifferent(firstHand.cards, CardsBox.handsUser1);

            // If the animation is ongoing and the round is valid, proceed
            if (this.check(startAnimID)) {
                if (activeSplitHandID === 0) {
                    // If the active split hand is the first hand
                    if (secondHand) {
                        this.handsUser1State = 'split';
                    }
                } else {
                    // If the active split hand is the second hand
                    this.handsUser2State = 'split';

                    // Add a card for the second hand
                    if (secondHand) {
                        await this.addCardDifferent(secondHand.cards, CardsBox.handsUser2);
                        this.handsUser1State = 'play';
                    }
                }
            }
        },
        // ↓ 更新牌桌之: 🎀 double
        // ↓ 此为两手牌专用，因为在只有1把牌的时候执行 double 将导致游戏结束，不会至此 
        async showDouble(oParams) {
            const { firstHand , secondHand } = oParams;
            // ↓ 已经针对第2把牌执行 double 
            if (secondHand.type == 2) {
                this.handsUser2State = '';
                await this.addCard(CardsBox.handsUser2, {
                    cardID: secondHand.cards[2],
                });
                return;
            }else{
                this.handsUser1State = 'play';
                this.handsUser2State = 'split'; // split 将触发高亮效果 
                await this.addCard(CardsBox.handsUser1, {
                    cardID: firstHand.cards[2],
                });
            }
        },
        // ↓ 更新牌桌之: 🎀 stand
        // ↓ 此为两手牌专用，因为在只有1把牌的时候执行 stand 将导致游戏结束，不会至此 
        showStand(oParams) {
            const { secondHand } = oParams;
            const activeSplitHandID = this.getActiveSplitHandID(oParams);
            if (activeSplitHandID === 0) {
                // If the active split hand is the first hand
                if (secondHand && secondHand.cards && secondHand.length > 0) {
                    this.handsUser1State = 'split';
                    this.handsBot;
                }
            } else {
                // If the active split hand is the second hand
                this.handsUser2State = 'split';
                this.handsUser1State = 'play';
            }
        },
        // ↓ 更新牌桌之: 🎀 游戏结束 
        // ↓ 如果首轮发牌玩家就获胜，需要弹出 21点图标，再按需将牌标绿，或标黄 
        async showEndRound({
            dealerHand,
            firstHand,
            secondHand,
            startAnimID,
            insuranceAmount,
        }) {
            const bHasSecondHand = secondHand?.points > 0; 
            const {cards: aDealerCards, points: botPoints} = dealerHand;
            await this.addCardDifferent(firstHand.cards, CardsBox.handsUser1);
            if (bHasSecondHand) {
                await this.addCardDifferent(secondHand.cards, CardsBox.handsUser2);
            }
            if (aDealerCards.length > 1) {
                await this.addDealerCardsForEnding({
                    dealerHand,
                    startAnimID,
                });
            }
            // Delay before showing end round
            await Sleep(ANIMATION_DELAY);
            // Check if animation is ongoing 
            if (!this.check(startAnimID)) return console.log('中断 2');
            // Check for blackjack
            const user1HasBlackjack = [
                !bHasSecondHand, // 没有第2手的牌 
                firstHand.points === 21,
                firstHand.cards.length === 2, // 用户第1手牌的张数 
            ].every(Boolean);
            const botHasBlackjack = botPoints === 21 && aDealerCards.length === 2;
            const isInsuranceRound = botHasBlackjack && insuranceAmount;
            // Update state for the first hand 
            this.handsUser1State = this.getStatus({
                botPoints,
                points: firstHand.points, 
                isInsuranceRound,
                user1HasBlackjack,
                botHasBlackjack,
            });
            if (!bHasSecondHand) return; // 没有第2手牌，返回 
            // Update state for the second hand if it exists
            this.handsUser2State = this.getStatus({
                botPoints,
                points: secondHand.points, 
                botHasBlackjack,
            });
        },
        // ↓ 插入卡牌到“庄家” 的手牌数组中
        // ↓ 专门用于终结游戏 
        async addDealerCardsForEnding(oParams){
            const { dealerHand, startAnimID }= oParams;
            const {cards, points} = dealerHand;
            this.oMusic.oAudio.flip.toPlay();
            // Set dealer's second card
            if (this.handsBot[1]){
                this.handsBot[1].cardID = cards[1];
                // this.handsBot[1].isOpen = true;
                await this.$nextTick();
            }
            // Calculate total points for dealer's hand
            const [botPoints1, botPoints2] = this.getTotalPoints(this.handsBot);
            // Delay before adding remaining cards
            await Sleep(ANIMATION_DELAY);
            // Check if animation is ongoing
            if (!this.check(startAnimID)) {
                return console.log('中断 1');
            }
            // Update dealer's hand points
            this.handsBotPoints[0] = botPoints1;
            this.handsBotPoints[1] = botPoints2;
            // Add remaining cards to dealer's hand
            for (let i = 2; i < cards.length; i++) { 
                await this.$nextTick();
                await this.addCard(CardsBox.handsBot, {
                    cardID: cards[i],
                });
            }
        },
        // ↓ 计算状态，播放音乐，并返回状态值 string 
        getStatus({ 
            points: userPoints,
            botPoints: dealerPoints,
            isInsuranceRound: isInsurance = false,
            user1HasBlackjack: userHasBlackjack = false,
            botHasBlackjack: botHasBlackjack,
        }) {
            let sStatusResult = '' as userStatus;
            if (isInsurance) {
                this.oMusic.oAudio.win.toPlay();
                sStatusResult ||= 'win';
            }
            if (userHasBlackjack && botHasBlackjack) {
                this.oMusic.oAudio.draw.toPlay();
                sStatusResult ||= 'equal';
            }
            if (!userHasBlackjack && botHasBlackjack) {
                this.oMusic.oAudio.lose.toPlay();
                sStatusResult ||= 'lose';
            }
            if (userPoints > 21) {
                this.oMusic.oAudio.lose.toPlay();
                sStatusResult ||= 'bust';
            }
            if (userPoints <= 21 && dealerPoints <= 21 && userPoints === dealerPoints) {
                this.oMusic.oAudio.draw.toPlay();
                sStatusResult ||= 'equal';
            }
            if (userPoints < 21 && dealerPoints > userPoints && dealerPoints <= 21) {
                this.oMusic.oAudio.lose.toPlay();
                sStatusResult ||= 'lose';
            }
            if (!sStatusResult){ 
                isDev && console.log("暂未取得状态值：❇️", ); 
                this.oMusic.oAudio.win.toPlay();
                sStatusResult = 'win'
            }
            return sStatusResult;
        },
        // ↓ 向“空” 桌子发牌
        // ↓ 用于开局，和刷新后重载 
        async setEmptyTable(){
            const {round, isFast, animation} = this; 
            let {reload_, firstHand, secondHand, dealerHand,} = round; 
            const dealerCards = dealerHand.cards;
            const _1stCards = firstHand.cards;
            const _2ndCards = secondHand?.cards || [];
            const aTaskList:AddCardTask[] = [{ 
                sTarget: CardsBox.handsUser1,
                oParams: {cardID: _1stCards[0], isRoundStartCard: isFast},
            },{
                sTarget: CardsBox.handsBot,
                oParams: {cardID: dealerCards[0], isRoundStartCard: isFast},
            },{
                sTarget: CardsBox.handsUser1,
                oParams: {cardID: _1stCards[1], isRoundStartCard: isFast},
            },{
                sTarget: CardsBox.handsBot, 
                oParams: {cardID: 'card_close', isRoundStartCard: isFast, needFlip: false },
            }];
            _1stCards.slice(2).forEach(cur=>{
                aTaskList.push({
                    sTarget: CardsBox.handsUser1,
                    oParams: {cardID: cur, isRoundStartCard: false},
                });
            });
            _2ndCards.forEach(cur=>{
                aTaskList.push({
                    sTarget: CardsBox.handsUser2,
                    oParams: {cardID: cur, isRoundStartCard: false},
                });
            });
            if (reload_){
                [CardsBox.handsUser1, CardsBox.handsBot, CardsBox.handsUser2,].forEach(sKey=>{
                    const oLastOne = aTaskList.findLast(cur=>cur.sTarget===sKey);
                    if (!oLastOne) return;
                    oLastOne.oParams.isLastCard = true; // 向最后一张卡添加标记
                });
                aTaskList.forEach(cur=>{
                    cur.oParams.exposed = true; 
                    cur.oParams.goFast = isFast || !cur.oParams.isLastCard; 
                });
                if (round.pairsBetAmount || round.tripleBetAmount){
                    this.isProMode = true;
                }
            }
            for (const [idx, cur] of aTaskList.entries()){
                const oNext = aTaskList[idx+1];
                // cur.oParams.needFlip = true;
                // cur.oParams.onStart = false;
                // cur.oParams.isSplitCard = true;
                // cur.oParams.isRoundStartCard = true;
                const toAwait = [
                    !reload_,
                    // animation && (!reload_ || cur.oParams.isLastCard),
                    // (!reload_ || oNext?.oParams?.isLastCard),
                    oNext?.oParams?.isLastCard,
                ].some(Boolean);
                if (animation && !reload_){
                    await this.addCard(cur.sTarget, cur.oParams);
                }else{
                    this.addCard(cur.sTarget, cur.oParams);
                }
            }
            this.activateCreentyHand(round); 
        },
        // ↓ 重要方法
        // ↓ 插入一张卡到某个数组（伴有音效和动画） 
        async addCard(
            sTarget:CardsBox, // 插入目标
            oParams:CardInterface, // 插入的元素
        ) {
            const targetArr = this[sTarget];
            const newCard = {
                needFlip: true,
                isOpen: false,
                onStart: true,
                isSplitCard: false,
                isRoundStartCard: false,
                ...oParams,
            };
            targetArr.push(newCard);
            const initID = this.initID;
            this.oMusic.oAudio.slide?.toPlay();
            let delayTime = 300;
            if (this.isFast && newCard.isRoundStartCard) delayTime = 500;
            if (this.animation) {
                newCard.isOpen = true;
                this.oMusic.oAudio.flip.toPlay();
                await Sleep(300);
                this.recalcHandsPoints(targetArr);
                return;
            }
            await Sleep(delayTime);
            if (!this.check(initID) || !newCard.needFlip) return;
            newCard.isOpen = true;
            this.oMusic.oAudio.flip.toPlay();
            setTimeout(
                () => {
                    if (this.check(initID)) this.recalcHandsPoints(targetArr);
                },
                this.animation ? ANIMATION_DELAY : 10,
            );
        },
        // ↓ 重新计算分数 
        recalcHandsPoints(targetArray) {
            // Determine the index of the target array
            const index = [this.handsBot, this.handsUser1, this.handsUser2].indexOf(targetArray);

            // Select the corresponding points array
            const pointsArray = [
                this.handsBotPoints,
                this.handsUser1Points,
                this.handsUser2Points
            ][ index ];

            // Calculate the total points for the target array
            const [totalPointsLow, totalPointsHigh] = this.getTotalPoints(targetArray);

            // Update the points array with the calculated values
            pointsArray[0] = totalPointsLow;
            pointsArray[1] = totalPointsHigh;
        },
        // ↓ 🌐 调用接口发起请求  
        async doRequest(oData:ParamsPart){
            const oParams = {
                // ↓ 拆分接口需要提交首选值 
                amount: this.round.initialBetAmount || this.oForm.amount, 
                frontID: Date.now(),
                ...oData,
            };
            const oRes = await EMIT_BLACKJACK_BET(oParams); 
            console.log("下注提交值与返回值如下：\n", deepCopy(oParams), '\n', deepCopy(oRes)); 
            if (!oRes || oRes.error){
                showNegativeNotify(oRes?.error); 
                return;
            }
            const {dealerHand} = oRes;
            if (checkIfExploded(oRes)){ 
                // ↓模仿原版，第2张牌不显示，始终为暗牌  
                dealerHand.cards.splice(1, 1/0);
            }
            return oRes;
        },
        // ↓ 点击了红色🟥主按钮 
        async submitTheBet() { 
            if (!betableCheck(this.oForm)) return;
            this.isUpdatingRound = true; // 禁用相关按钮
            const initialID = this.initID; 
            // Check if round status allows placing a bet
            // ↓ 本局已经结束，则开新局 
            if (['lose', 'cashout', 'equal'].includes(this.roundStatus)) {
                this.roundStatus = 'await';
                await this.removeAllCards();
                await Sleep(500); // Wait for 500 milliseconds
                if (!this.check(initialID)) {
                    this.isUpdatingRound = false;
                    return;
                }
            }
            this.oJoinStateStore.gameRunning = true; 
            // Prepare bet options based on game mode 
            const oRes = await this.doRequest({
                type: Action.Bet,
                ...this.getProModeAmountObject(), // 按需取得 pro mode 的金额信息  
            });
            if (!oRes || oRes.error) {
                this.isUpdatingRound = false; 
                this.oJoinStateStore.gameRunning = false; 
                return;
            }
            const betResult:RoundDataInterface = {
                pairsBetAmount: 0,
                pairsWinAmount: 0,
                tripleBetAmount: 0,
                tripleWinAmount: 0,
                ...oRes,
            };
            this.updateRound(betResult, Action.Bet); 
        },
        // ↓ 取得 pro 模式的下注金额信息 
        getProModeAmountObject(){
            const oResult:ProModeInfo = {};
            if (!this.isProMode) return oResult;
            const {pairsAmount, tripleAmount} = this.oProInput || {}; 
            if (pairsAmount > 0){
                oResult.pairsAmount = pairsAmount;
            }
            if (tripleAmount > 0){
                oResult.tripleAmount = tripleAmount;
            }
            return oResult;
        },
        
        // ↓ 清空旧的游戏，点击下注按钮时将调用 
        async removeAllCards(animate = true) {
            this.round = deepCopy(this.roundEmptyObj);
            // Play clear sound and animate if specified
            if (animate) {
                this.oMusic.oAudio.clear.toPlay();
                this.showHideAnim = true;
                await Sleep(150);
                this.showHideAnim = false;
            }
            // Clear hands and points for all players
            this.handsBot = [];
            this.handsUser1 = [];
            this.handsUser2 = [];
            this.handsBotPoints = [0, 0];
            this.handsUser1Points = [0, 0];
            this.handsUser2Points = [0, 0];
            // Reset hands' states
            this.handsBotState = 'play';
            this.handsUser1State = 'play';
            this.handsUser2State = 'play';
        },
        // ↓ 传入新的卡牌列表，注入到旧的卡牌列表 
        // ↓ 游戏终结时 showEndRound() 内有调用此方法 
        // ↓ 执行 Hit 后将调用此方法 
        async addCardDifferent(aCards, sTarget: CardsBox) {
            const targetArray = this[sTarget];
            const newCards = [...aCards].slice(targetArray.length);
            if (!newCards.length) return;
            // If there are new cards, add them to the targetArray
            for (let i = 0; i < newCards.length; i++) { 
                await this.addCard(sTarget, {
                    cardID: newCards[i],
                });
                // Add a delay for animation
                await Sleep(ANIMATION_DELAY);
            }
        },
        changeMode(){
            if (this.gamePlaying){
                showNegativeNotify({
                    i18n: 'GameBlackJack.cannotChange',
                    type: 'warning',
                    timeout: 1_000 * 11,
                });
            }
        },
    },
};
</script>


<style lang="scss" scoped src="./style/blackjack-all.scss" ></style>
<style lang="scss" scoped src="./style/blackjack.scss"></style>
<style lang="scss" scoped src="./style/blackjack-wrapper.scss"></style>
<style lang="scss" scoped src="./style/blackjack-game-background__inner.scss"></style>
<style lang="scss" scoped src="./style/blackjack-card.scss"></style>

